export default __webpack_public_path__ + "static/media/Gym.15caa25a.jpg";